import styled from "@emotion/styled";
import Colors from "/styles/colors";
import { MOBILE_QUERY_MAX_WIDTH } from "constants/vp-sizes";
import { WORK_OS_IRIS_COLOR_NAME } from "styles/color-consts";
export const StyledContactSalesHubspotFormComponent = styled.div`
  .monday-loader-wrapper {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  > div {
    width: 100%;
  }

  background: ${({ backgroundColor })=>Colors[backgroundColor] || Colors["white"]};
  padding: 48px;
  box-shadow: ${({ formShadow })=>formShadow ? "0px 8px 24px rgba(0, 0, 0, 0.100091)" : "none"};
  border-radius: 12px;
  margin: 24px 12px;
  display: flex;
  justify-content: center;
  align-items: center;

  #reactHubspotForm2 {
    display: flex;
    justify-content: center;
  }

  .hbspt-form {
    fieldset {
      max-width: 100%;
      text-align: left;
      &.form-columns-1,
      &.form-columns-2 {
        .hs-form-field {
          text-align: left;
          margin-bottom: 30px;
          font-size: 0.731rem;
          position: relative;
        }

        .hs-input {
          width: 100%;
        }

        .legal-consent-container {
          .hs-richtext {
            font-size: 0.75rem;
            text-align: center;
          }
        }

        .hs-fieldtype-booleancheckbox {
          margin-bottom: 8px;

          .inputs-list {
            padding-inline-start: 8px;

            .hs-form-booleancheckbox {
              .hs-form-booleancheckbox-display {
                display: flex;
                align-items: center;

                .hs-input[type="checkbox"] {
                  width: unset;
                  height: unset;
                  margin-right: 8px;
                }
              }

              ::marker {
                color: transparent;
              }
            }
          }
        }
      }

      &.form-columns-1 {
        .hs-form-field {
          width: 100%;
        }
      }

      &.form-columns-2 {
        .hs-form-field {
          width: 50%;
        }
      }

      .input {
        input,
        select,
        textarea {
          height: 40px;
          border-radius: 4px;
          border: #d3d2d2 1px solid;
          text-indent: 10px;
          color: #333;
          width: 100%;
          outline: none;
        }

        select {
          text-indent: 10px;
        }

        textarea {
          height: 80px;
          width: 100% !important;
          resize: none;
        }

        ul[role="checkbox"] {
          padding-inline-start: 8px;

          .hs-form-checkbox {
            .hs-form-checkbox-display {
              display: flex;
              align-items: center;

              .hs-input[type="checkbox"] {
                width: unset;
                height: unset;
                margin-right: 8px;
              }
            }

            ::marker {
              color: transparent;
            }
          }
        }
      }

      .hs-form-field {
        label {
          margin-bottom: 5px;
          display: inline-block;
          text-indent: 5px;
          font-size: ${({ textSize })=>textSize || "0.875rem"};
          color: ${({ textColor })=>Colors[textColor] || Colors["black"]};
        }
      }

      .invalid.error {
        border-color: ${Colors["brand-red"]};
      }
    }

    .hs-form-required {
      margin-left: 8px;
      color: ${Colors["brand-red"]};
    }

    .no-list {
      &.hs-error-msgs {
        padding-left: 0;
        margin-top: 2px;
        &.inputs-list {
          list-style-type: none !important;
          position: absolute;
          margin-left: 5px;
          width: 100%;

          & :not(:first-of-type) {
            display: none;
          }

          li > label > a {
            display: none;
          }

          label {
            font-size: 0.6875rem;
            text-indent: 0px;
          }
        }
      }
    }

    .hs_submit {
      display: flex;
      justify-content: center;
      input {
        user-select: none;
        line-height: 17px;
        outline: none;
        text-align: center;
        cursor: pointer;
        border-radius: 40px;
        border: none;
        font-size: 0.875rem;
        transition: 0.1s ease background-color;
        padding: 14px 32px;
        font-weight: 300;
        background: ${({ ctaButtonColor })=>Colors[ctaButtonColor] || Colors[WORK_OS_IRIS_COLOR_NAME]};
        color: ${({ ctaTextColor })=>Colors[ctaTextColor] || Colors["white"]};
      }
    }

    .hs_how_can_our_consulting_team_help_you {
      margin-bottom: 5px;
      display: inline-block;
      font-size: 0.731rem;
      width: 100%;
    }

    .hs_error_rollup {
      display: none;
    }
  }

  @media (max-width: ${MOBILE_QUERY_MAX_WIDTH}) {
    padding: 24px 12px 80px 12px;
    margin: 0;
  }

  &.use-base-form {
    padding: 0;
    width: 100%;
  }

  .hubspot-contact-form-wrapper {
    .base-form {
        padding: 0;
        box-shadow: none;
    }

    .generic-form-input-component .form-input-wrapper {
        margin-bottom: 16px ;
    }
    
    .generic-form-input-component .input-title.contact-form-required-input:after,
    .hs-form-required,
    .hs-form label:after,
    .hs-fieldtype-text label:after,
    .hs-fieldtype-select label:after {
      display: none ;
    }

    .privacy-notice-wrapper {
      display: block ;
      justify-content: unset ;
    }

    .contact-form-row {
      flex-direction: row;
      align-items: center;
    }
  }

`;
